import { createActionGroup, props } from '@ngrx/store';
import { TournamentsResponse } from '../../models/api/responses/tournaments.response';
import { AllTournamentsType } from '../reducers/allTournaments.reducer';
import { BadResponseWithError } from '../../../shared/models/bad-response-with-error.interface';

export type Filter = { [key: string]: string | string[] };

export const AllTournamentsActions = createActionGroup({
    source: 'All Tournaments Page',
    events: {
        'Fetch All Tournaments': props<{
            payload: {
                type: AllTournamentsType;
                patchExistingTournaments: boolean;
                page: number;
                filters: Filter;
            };
        }>(),
        'Fetch All Tournaments Success': props<{
            payload: {
                type: AllTournamentsType;
                patchExistingTournaments: boolean;
                response: TournamentsResponse;
            };
        }>(),
        'Fetch All Tournaments Failure': props<{
            payload: BadResponseWithError;
        }>(),
    },
});
